import React, { useEffect, useState, useRef } from "react";
import { registerSip, callNumber, hangup,
    toggleMute,
    toggleHold,
    getSession
} from "./SipClient";
import "./dialer.css";

import {
    Web
  } from "sip.js";

const API = process.env.REACT_APP_API;

const DISPOSITIONS = [
  "No Answer",
  "Interested",
  "Callback",
  "DNC",
  "Sale"
];

const Dialer = () => {
    const [callState, setCallState] = useState("IDLE");
    const [timer, setTimer] = useState(0);
    const [wrapUpTimer, setWrapUpTimer] = useState(10);
    const [muted, setMuted] = useState(false);
    const [onHold, setOnHold] = useState(false);
    const [agentStatus, setAgentStatus] = useState("READY");
    const [lead, setLead] = useState(null);
    const [selectedDisposition, setSelectedDisposition] = useState("");
    const [recording, setRecording] = useState(false);
    const [callLogs, setCallLogs] = useState([]);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [filter, setFilter] = useState("");
    const [showModal, setShowModal] = useState(false);

    const [totalChargeToday, setTotalChargeToday] = useState(0);
    const [queueLeads, setQueueLeads] = useState([]);
    const [loadingQueue, setLoadingQueue] = useState(false);

    const intervalRef = useRef(null);
    const timerRef = useRef(null);
    const timerValueRef = useRef(0);
    const wrapRef = useRef(null);
    const finalDurationRef = useRef(0);


    const [stats, setStats] = useState({
        callsToday: 0,
        connected: 0,
        sales: 0,
        conversion: 0,
        activeAgents: 0,
        callsInProgress: 0,
        totalChargeToday: 0,
        totalMinutesToday: 0,
        us: {
            ratePerMinute: 0,
            totalMinutes: 0,
            totalCharge: 0
        },
        india: {
            ratePerMinute: 0,
            totalMinutes: 0,
            totalCharge: 0
        }
    });

    useEffect(() => {
        registerSip("agent_1");

        const init = async () => {
          const res = await fetch(`${API}/api/agent-status/7ab94b02-9ee8-4bc9-8207-2ccd7d290040`);
          const data = await res.json();
          setAgentStatus(data.status);

          if (data.status === "READY") {
            fetchNextLead();
          }
        };

        init();
    }, []);

    useEffect(() => {
        fetchStats();
        const interval = setInterval(fetchStats, 5000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        fetchQueueLeads();
    }, []);

    // const fetchCallLogs = async () => {
    //     const res = await fetch(`${API}/api/call-logs`);
    //     const data = await res.json();
    //     setCallLogs(data);
    // };
    const fetchCallLogs = async (pageNumber = 1, disposition = filter) => {
        try {
          const res = await fetch(
            `${API}/api/call-history/7ab94b02-9ee8-4bc9-8207-2ccd7d290040?page=${pageNumber}&limit=10&disposition=${disposition || ""}`
          );

          const result = await res.json();

          setCallLogs(result.data || []);
          setTotalPages(result.totalPages || 1);
          setPage(pageNumber);

        } catch (err) {
          console.error("History fetch error:", err);
          setCallLogs([]);
        }
    };

    const fetchQueueLeads = async () => {
        try {
          setLoadingQueue(true);

          const res = await fetch(
            `${API}/api/lead-queue/7ab94b02-9ee8-4bc9-8207-2ccd7d290040`
          );

          const data = await res.json();

          setQueueLeads(data.leads || []);
        } catch (err) {
          console.error("Queue fetch error:", err);
          setQueueLeads([]);
        } finally {
          setLoadingQueue(false);
        }
      };

    useEffect(() => {
        fetchCallLogs();
    }, []);

    useEffect(() => {
        if (showModal) {
          fetchCallLogs(1);
        }
    }, [showModal]);

    useEffect(() => {
        if (callState === "CONNECTED") {
            intervalRef.current = setInterval(() => {
                setTimer(prev => {
                    const newTime = prev + 1;
                    timerValueRef.current = newTime;
                    return newTime;
                });
            }, 1000);
        }
        if (callState === "ENDED") {
            setTimer(0);
            timerValueRef.current = 0;
            clearInterval(intervalRef.current);
        }

        return () => clearInterval(intervalRef.current);
    }, [callState]);

    useEffect(() => {
        console.log("CALL STATE CHANGED:", callState);
      }, [callState]);

    useEffect(() => {
        const ring = document.getElementById("ringTone");
        const dial = document.getElementById("dialTone");

        if (!ring || !dial) return;

        // Always stop everything first
        dial.pause();
        dial.currentTime = 0;

        ring.pause();
        ring.currentTime = 0;

        if (callState === "DIALING") {
          dial.play().catch(() => {});
        }

        if (callState === "RINGING") {
            ring.loop = true;
            ring.currentTime = 0;
            ring.play().catch(e => console.log("Ring blocked:", e));
        }

    }, [callState]);

    const fetchLead = async () => {
        try {
            const res = await fetch(`${API}/api/next-lead/7ab94b02-9ee8-4bc9-8207-2ccd7d290040`);
            const data = await res.json();
            setLead(data.lead);
        } catch (err) {
            console.error("Lead fetch error:", err);
        }
    };

    const fetchStats = async () => {
        const res = await fetch(`${API}/api/dashboard-stats`);
        const data = await res.json();
        setStats(data);
    };

    const updateAgentStatus = async (status) => {
        setAgentStatus(status);

        await fetch(`${API}/api/agent-status`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            agentId: "7ab94b02-9ee8-4bc9-8207-2ccd7d290040",
            status
          })
        });
      };

    const fetchNextLead = async () => {
        const res = await fetch(`${API}/api/next-lead/7ab94b02-9ee8-4bc9-8207-2ccd7d290040`);
        const data = await res.json();
        setLead(data.lead);
    };

    const handleCall = async () => {
        if (agentStatus !== "READY") {
            alert("Agent not in READY state");
            return;
        }

        if (!lead?.phone) return;
        await updateAgentStatus("BUSY");

        await callNumber(lead.phone, async (state) => {
          setCallState(state);

          if (state === "CONNECTED") {
            setRecording(true);

            await fetch(`${API}/api/lead-status`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                leadId: lead.id,
                status: "IN_CALL",
                agentId: "7ab94b02-9ee8-4bc9-8207-2ccd7d290040"
              })
            });

            // 🔥 Auto Voicemail Detection
            setTimeout(() => {
              if (callState === "CONNECTED" && timerValueRef.current < 20) {
                console.log("Voicemail detected - auto ending");

                hangup();
              }
            }, 20000); // 20 sec check
          }

          if (state === "ENDED") {
            setRecording(false);
            clearInterval(intervalRef.current);

            finalDurationRef.current = timerValueRef.current;

            setTimer(0);
            timerValueRef.current = 0;

            // 🔥 NORMAL CALL → SHOW DISPOSITION
            setCallState("WRAP_UP");
            await updateAgentStatus("WRAP_UP");
          }
        });
    };

    const startWrapUp = () => {
        setCallState("WRAP_UP");
        updateAgentStatus("WRAP_UP");
        setWrapUpTimer(10);

        wrapRef.current = setInterval(() => {
          setWrapUpTimer(prev => {
            if (prev <= 1) {
              clearInterval(wrapRef.current);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      };

    const handleHangup = async () => {
        await hangup();
    };

    const submitDisposition = async () => {
        if (!selectedDisposition) {
          alert("Disposition required!");
          return;
        }

        let newStatus = "COMPLETED";

        if (selectedDisposition === "No Answer") {
          newStatus = "NO_ANSWER";
        } else if (selectedDisposition === "Callback") {
          newStatus = "CALLBACK";
        } else if (selectedDisposition === "DNC") {
          newStatus = "DNC";
        } else if (selectedDisposition === "Sale") {
          newStatus = "COMPLETED";
        }

        await fetch(`${API}/api/lead-status`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            leadId: lead.id,
            status: newStatus,
            agentId: "7ab94b02-9ee8-4bc9-8207-2ccd7d290040",
            duration: finalDurationRef.current
          })
        });

        // Reset UI
        setSelectedDisposition("");
        setCallState("IDLE");
        setLead(null);

        await updateAgentStatus("READY");
        await fetchQueueLeads();

        // 🔥 ALWAYS fetch next lead
        fetchNextLead();
    };

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${s < 10 ? "0" : ""}${s}`;
    };

    const formatDuration = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;

        return `${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m ${String(s).padStart(2, '0')}s`;
    };

    const toggleMute = () => {
        const session = getSession();
        const pc = session.sessionDescriptionHandler.peerConnection;
        pc.getSenders().forEach(sender => {
          if (sender.track.kind === "audio") {
            sender.track.enabled = muted;
          }
        });
        setMuted(!muted);
    };

    const toggleHold = async () => {
        const session = getSession();
        if (!session) return;

        try {
            if (!onHold) {
              await session.invite({
                sessionDescriptionHandlerModifiers: [
                  Web.holdModifier
                ]
              });

              setOnHold(true);
              setCallState("HOLD");

            } else {
              await session.invite(); // resume normal SDP

              setOnHold(false);
              setCallState("CONNECTED");
            }

          } catch (err) {
            console.error("Hold failed:", err);
          }
    };

    return (
        <div className="dialer-container">

          {/* ===================== TOP BAR ===================== */}
          <header className="top-bar">

            <div className="agent-info">
              <span className="agent-name">Agent: agent_1</span>
            </div>

            <div className="agent-controls">
            <select
                value={agentStatus}
                disabled={callState !== "IDLE"}
                onChange={async (e) => {
                    const newStatus = e.target.value;
                    await updateAgentStatus(newStatus);

                    if (newStatus === "READY") {
                        setCallState("IDLE");
                        fetchNextLead();
                    } else {
                        setLead(null);
                        setCallState("IDLE");
                    }
                }}
                className="status-select"
            >
                <option value="READY">Ready</option>
                <option value="BUSY">Busy</option>
                <option value="BREAK">On Break</option>
                <option value="WRAP_UP">Wrap-up</option>
              </select>
            </div>

            <div className={`call-state-badge ${callState.toLowerCase()}`}>
              {callState === "IDLE" && "Idle"}
              {callState === "DIALING" && "Dialing..."}
              {callState === "RINGING" && "Ringing..."}
              {callState === "CONNECTED" && "Connected"}
              {callState === "HOLD" && "On Hold"}
              {callState === "WRAP_UP" && `Wrap-up (${wrapUpTimer}s)`}
            </div>

          </header>


          {/* ===================== MAIN LAYOUT ===================== */}
          <div className="main-layout">

            {/* ========== LEFT PANEL (Stats) ========== */}
            <aside className="left-panel">
                {/* ===== Campaign Stats ===== */}
                <div className="panel-card">
                    <h4>Campaign Stats</h4>

                    <div className="stat-row">
                    <span>Calls Today</span>
                    <strong>{stats.callsToday}</strong>
                    </div>

                    <div className="stat-row">
                    <span>Connected</span>
                    <strong>{stats.connected}</strong>
                    </div>

                    <div className="stat-row">
                    <span>Sales</span>
                    <strong>{stats.sales}</strong>
                    </div>

                    <div className="stat-row">
                    <span>Conversion</span>
                    <strong>{stats.conversion}%</strong>
                    </div>

                    <div className="stat-row">
                    <span>Total Minutes</span>
                    <strong>{stats.totalMinutesToday}</strong>
                    </div>

                    <div className="stat-row">
                    <span>Total Cost</span>
                    <strong>${stats.totalChargeToday}</strong>
                    </div>
                </div>

                <div className="panel-card">
                    <h4>Telnyx Pricing</h4>

                    <div className="stat-row">
                        <span>🇺🇸 US Rate / Min</span>
                        <strong>${stats.us?.ratePerMinute}</strong>
                    </div>

                    <div className="stat-row">
                        <span>🇮🇳 India Rate / Min</span>
                        <strong>${stats.india?.ratePerMinute}</strong>
                    </div>
                </div>

                {/* ===== Live Monitoring ===== */}
                <div className="panel-card">
                    <h4>Live Monitoring</h4>

                    <div className="stat-row">
                    <span>Active Agents</span>
                    <strong>{stats.activeAgents}</strong>
                    </div>

                    <div className="stat-row">
                    <span>Calls In Progress</span>
                    <strong>{stats.callsInProgress}</strong>
                    </div>
                </div>

                <div className="panel-card">
                    <h4>Country Cost Summary (All Time)</h4>

                    <div className="stat-row">
                        <span>🇺🇸 US Total Cost</span>
                        <strong>${stats.us?.totalChargeAllTime?.toFixed(4)}</strong>
                    </div>

                    <div className="stat-row">
                        <span>🇮🇳 India Total Cost</span>
                        <strong>${stats.india?.totalChargeAllTime?.toFixed(4)}</strong>
                    </div>
                </div>

                {/* ===== Recent Calls ===== */}
                <div className="panel-card history-section">
                    <div className="history-header">
                        <h4>Call History</h4>
                        <button className="view-all-btn" onClick={() => setShowModal(true)}>View All</button>
                    </div>

                    {callLogs.slice(0, 10).map(call => (
                        <div key={call.id} className="history-item">

                        <div className="history-left">
                            <div className="call-icon">
                            📞
                            </div>
                        </div>

                        <div className="history-body">
                            <div className="history-top">
                            <span className="lead-name">
                                {call.lead?.name || "Unknown"}
                            </span>
                            </div>

                            <div className="history-middle">
                                <span className={`status ${call.disposition.toLowerCase()}`}>
                                    {call.disposition}
                                </span>

                                <span className={`call-type ${call.rate == 0.0035 ? "domestic" : "international"}`}>
                                    {call.rate == 0.0035 ? "Domestic" : "International"}
                                </span>
                            </div>

                            <div className="history-middle">
                            {call.lead?.phone}
                            </div>

                            <div className="history-bottom">
                                <span>{formatDuration(call.duration)}</span>
                            </div>

                            <div className="history-bottom">
                                <span>{new Date(Number(call.created_at)).toLocaleString()}</span>
                            </div>

                            <div className="history-bottom">
                                <span className="call-charge">
                                    ${call.charge?.toFixed(4)}
                                </span>
                            </div>
                        </div>

                        </div>
                    ))}
                </div>

            </aside>

            {/* ========== CENTER PANEL (Call Area) ========== */}
            {/* <section className="center-panel">
                <div className="call-wrapper">

                    {lead && (
                    <div className="lead-card">
                        <div className="lead-name">{lead.name}</div>
                        <div className="lead-phone">{lead.phone}</div>
                    </div>
                    )}

                    <div className="call-actions">

                    {callState === "IDLE" && (
                        <button className="call-btn" onClick={handleCall}>
                        Call
                        </button>
                    )}

                    {(callState === "DIALING" ||
                        callState === "RINGING" ||
                        callState === "CONNECTED" ||
                        callState === "HOLD") && (
                        <button className="hangup-btn" onClick={handleHangup}>
                        End Call
                        </button>
                    )}

                    <div className="timer">
                        {callState === "CONNECTED"
                        ? formatTime(timer)
                        : "00:00"}
                    </div>

                    {callState === "CONNECTED" && recording && (
                        <div className="recording-indicator">
                        ● Recording
                        </div>
                    )}

                    {callState === "CONNECTED" && (
                        <div className="extra-controls">
                        <button
                            className={`control-btn ${muted ? "active" : ""}`}
                            onClick={toggleMute}
                        >
                            {muted ? "Unmute" : "Mute"}
                        </button>

                        <button
                            className={`control-btn ${onHold ? "active" : ""}`}
                            onClick={toggleHold}
                        >
                            {onHold ? "Resume" : "Hold"}
                        </button>
                        </div>
                    )}

                    </div>

                </div>
            </section> */}
            <section className="center-panel">

                <div className="glass-card">

                    {lead && (
                        <>
                        <div className="lead-name">{lead.name}</div>
                        <div className="lead-phone">{lead.phone}</div>
                        </>
                    )}

                    {/* CALL BUTTON */}
                    <div className="dial-area">

                        {callState === "IDLE" && (
                        <button className="dial-btn pulse" onClick={handleCall}>
                            📞
                        </button>
                        )}

                        {(callState === "DIALING" || callState === "RINGING") && (
                        <button className="dial-btn ringing" onClick={handleHangup}>
                            📞
                        </button>
                        )}

                        {(callState === "CONNECTED" || callState === "HOLD") && (
                        <button className="dial-btn active-call" onClick={handleHangup}>
                            ❌
                        </button>
                        )}

                        <div className="timer-display">
                        {callState === "CONNECTED" ? formatTime(timer) : "00:00"}
                        </div>

                        {/* Wave Visualizer */}
                        {callState === "CONNECTED" && (
                        <div className="wave-container">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        )}

                        {callState === "CONNECTED" && (
                        <div className="extra-controls">
                            <button
                            className={`control-btn ${muted ? "active" : ""}`}
                            onClick={toggleMute}
                            >
                            {muted ? "Unmute" : "Mute"}
                            </button>
                        </div>
                        )}

                    </div>

                    {callState === "WRAP_UP" && (
                        <div className="wrapup-overlay">

                            <h3>Select Disposition</h3>

                            <div className="disposition-buttons">
                            {DISPOSITIONS.map((d) => (
                                <button
                                key={d}
                                className={
                                    selectedDisposition === d
                                    ? "disp-btn active"
                                    : "disp-btn"
                                }
                                onClick={() => setSelectedDisposition(d)}
                                >
                                {d}
                                </button>
                            ))}
                            </div>

                            <button
                            className="submit-disp-btn"
                            onClick={submitDisposition}
                            disabled={!selectedDisposition}
                            >
                            Submit
                            </button>

                        </div>
                    )}

                </div>

            </section>

            {/* ========== RIGHT PANEL (Lead Queue) ========== */}
            <aside className="right-panel">

            <div className="panel-card queue-section">

                <div className="queue-header">
                    <h4>Lead Queue</h4>
                    <span className="queue-count">
                    {queueLeads.length} Leads
                    </span>
                </div>

                <div className="queue-scroll">
                    {loadingQueue && (
                        <div className="queue-loading">Loading queue...</div>
                    )}

                    {!loadingQueue && queueLeads.length === 0 && (
                        <div className="queue-empty">
                        No leads in queue
                        </div>
                    )}

                    {!loadingQueue && queueLeads.map((item, index) => {

                        const isCurrent = lead?.id === item.id;

                        return (
                        <div
                            key={item.id}
                            className={`queue-item ${isCurrent ? "active-lead" : ""}`}
                        >

                            <div className="queue-top">
                            <span className="queue-name">
                                {item.name}
                            </span>

                            <span className={`queue-status ${item.status?.toLowerCase()}`}>
                                {item.status}
                            </span>
                            </div>

                            <div className="queue-phone">
                            {item.phone}
                            </div>

                            <div className="queue-meta">
                            <span>
                                #{index + 1}
                            </span>

                            {isCurrent && (
                                <span className="current-badge">
                                Calling Now
                                </span>
                            )}
                            </div>

                        </div>
                        );
                    })}
                      </div> {/* queue-scroll */}
                </div>
            </aside>
          </div>

          {showModal && (
            <div className="history-modal">
                <div className="modal-content">

                <div className="modal-header">
                    <h3>Full Call History</h3>
                    <button className="close-btn" onClick={() => setShowModal(false)}>✕</button>
                </div>

                {/* Filter */}
                <div className="filter-bar">
                    <select
                    value={filter}
                    onChange={(e) => {
                        const value = e.target.value;
                        setFilter(value);
                        fetchCallLogs(1, value);
                    }}
                    >
                    <option value="">All</option>
                    <option value="COMPLETED">Completed</option>
                    <option value="NO_ANSWER">No Answer</option>
                    <option value="CALLBACK">Callback</option>
                    <option value="DNC">DNC</option>
                    </select>
                </div>

                <div className="modal-body">
                    {callLogs.length === 0 && (
                        <div className="no-records">No call records found</div>
                    )}

                    {callLogs.map((log) => (
                        <div key={log.id} className="history-card">

                        <div className="card-left">
                            <div className="card-icon">📞</div>
                        </div>

                        <div className="card-content">
                            <div className="card-top">
                                <div className="card-left-info">
                                    <div className="card-name">
                                    {log.lead?.name || "Unknown"}
                                    </div>
                                </div>
                                <div className="card-right-info">
                                    <span className={`call-type ${log.rate == 0.0035 ? "domestic" : "international"}`}>
                                        {log.rate == 0.0035 ? "Domestic" : "International"}
                                    </span>
                                    <span className={`card-status ${log.disposition?.toLowerCase()}`}>
                                        {log.disposition}
                                    </span>
                                </div>
                            </div>

                            <div className="card-phone">
                            {log.lead?.phone}
                            </div>

                            <div className="card-bottom">
                                <span>{formatDuration(log.duration)}</span>
                                <span className="call-charge">
                                    $ {log.charge?.toFixed(4)}
                                </span>
                                <span>{new Date(Number(log.created_at)).toLocaleString()}</span>
                            </div>
                        </div>

                        </div>
                    ))}
                </div>

                <div className="pagination">
                    <button
                        disabled={page <= 1}
                        onClick={() => {
                        const newPage = page - 1;
                        fetchCallLogs(newPage, filter);
                        }}
                    >
                        Prev
                    </button>

                    <span>{page} / {totalPages}</span>

                    <button
                        disabled={page >= totalPages}
                        onClick={() => {
                        const newPage = page + 1;
                        fetchCallLogs(newPage, filter);
                        }}
                    >
                        Next
                    </button>
                </div>

                </div>
            </div>
          )}

          {/* ===================== AUDIO ELEMENTS ===================== */}
          <audio id="remoteAudio" autoPlay playsInline />
          <audio id="ringTone" preload="auto">
            <source src="/tones/ring.wav" type="audio/wav" />
        </audio>

        <audio id="dialTone" preload="auto">
            <source src="/tones/dial.wav" type="audio/wav" />
        </audio>
        </div>
      );
};

export default Dialer;
